import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ReactPaginate from "react-paginate";
import styles from "./Pagination.module.styl";

function Pagination({ pageCount, onPageChange, forcePage, className }) {
    const handlePageChange = ({ selected }) => {
        onPageChange && onPageChange(selected + 1);
    };

    return (
        <ReactPaginate
            pageCount={pageCount}
            pageRangeDisplayed={5}
            marginPagesDisplayed={1}
            onPageChange={handlePageChange}
            previousLabel="← Назад"
            nextLabel="Вперед →"
            forcePage={forcePage && forcePage - 1}
            containerClassName={cx(styles.container, className)}
            previousClassName={styles.previousPage}
            nextClassName={styles.nextPage}
            previousLinkClassName={styles.link}
            nextLinkClassName={styles.link}
            disabledLinkClassName={styles.disabledLink}
            pageClassName={styles.page}
            pageLinkClassName={styles.pageLink}
            activeLinkClassName={styles.activePageLink}
        />
    );
}

Pagination.propTypes = {
    pageCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func,
    forcePage: PropTypes.number,
    className: PropTypes.string,
};

export default Pagination;
